import * as React from 'react';
import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import { classes, st } from './ErrorMessageWrapper.cssVars.st.css';
import { useTranslation } from '../../../../contexts/translation-context';
export const ErrorMessageWrapper = _ref => {
  let {
    className,
    visible,
    suffixText,
    message,
    messageId,
    'data-hook': dataHook
  } = _ref;
  const {
    t
  } = useTranslation();
  const getMessage = () => /*#__PURE__*/React.createElement("div", {
    className: classes.message,
    id: messageId
  }, /*#__PURE__*/React.createElement(ErrorSmall, {
    className: classes.icon,
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.hiddenMessageA11y
  }, t('form.error.prefix.a11y')), /*#__PURE__*/React.createElement("span", {
    "data-hook": "errormessagewrapper-message"
  }, message));
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.root, {
      visible
    }, className),
    "data-hook": dataHook,
    "aria-live": "polite"
  }, visible && (suffixText ? /*#__PURE__*/React.createElement("div", {
    className: classes.messageWithSuffix
  }, getMessage(), suffixText) : getMessage()));
};
//# sourceMappingURL=ErrorMessageWrapper.js.map